import { IPaymentMethod } from "./paymentMethod"

export enum PolicyStatus {
  Active = 'active',
  Expired = 'expired',
  CopayBlocked = 'copay_blocked',
  WithoutCopay = 'without_copay'
}

export interface IPolicy {
  id: number
  agreementAccepted: boolean
  hasPhoneNumber: boolean
  hasPaymentMethod: boolean
  paymentMethod: IPaymentMethod,
  isExpired: boolean,
  status: string
  copayActivated: boolean
  phoneNumber: string
  isCopayActivatedButNotYetActive: boolean
  howManyDaysLeftUntilCopayActivation: number | null
  howManyDaysLeftUntilRecommendedCopayBlock: number | null
  howManyDaysLeftUntilRecommendedCopayUnBlock: number | null
  test: boolean
  number: string
}

export interface IPolicyWithBalanceInfo {
  policy: IPolicy
  balance: number
  totalIncome: number,
  totalExpenses: number
}

export interface ILoginUrl {
  url: string
}